"use client";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store } from "./store";
import { persistor } from "./store";

function ReduxProvider({ children }: { children: React.ReactNode }) {
  if (typeof window === "undefined") {
    return (
      <Provider store={store}>
        {children}
      </Provider>
    )
  }
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>{children}</PersistGate>
    </Provider>
  );
}

export default ReduxProvider;
